<div id="item-search-container" class="container mx-auto lg:px-20 min-h-auto">
    <div class="flex flex-col items-center justify-center text-center mt-2 px-2">
        <div class="text-[150px] text-custom-blue mb-4 relative">
            <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
        <fa-icon
                [icon]="faX"
                class="absolute 
                    top-[42%] left-[42%]
                    -translate-x-1/2 -translate-y-1/2
                    text-3xl text-custom-blue font-bold">
            </fa-icon>
        </div>
        <p class="text-xl  lg:text-2xl font-semibold mb-2">
            @if (searchQuery) {
                We didn’t find any results for <span class="font-bold">“{{ searchQuery }}”</span>
            } @else if (categoryName) {
                We didn’t find any items in <span class="font-bold">“{{ categoryName }}”</span>
            } @else {
                We didn’t find any items
            }
        </p>
        <p class="  text-sm lg:text-base text-gray-600 max-w-md mt-6">
            Try checking your spelling, using different or more general keywords, or searching with fewer words.
        </p>
    </div>
</div>